import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavContainerComponent } from '@app/pcs/shared/components/sidenav/nav-container.component';
import { NavGroupComponent } from '@app/pcs/shared/components/sidenav/nav-group.component';
import { NavItemComponent } from '@app/pcs/shared/components/sidenav/nav-item.component';
import { NavLinkItemComponent } from '@app/pcs/shared/components/sidenav/nav-link-item.component';
import { NavLinksComponent } from '@app/pcs/shared/components/sidenav/nav-links.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  declarations: [
    NavLinkItemComponent,
    NavLinksComponent,
    NavContainerComponent,
    NavItemComponent,
    NavGroupComponent
  ],
  exports: [
    NavLinksComponent,
    NavContainerComponent,
    NavItemComponent,
    NavGroupComponent,
    NavLinkItemComponent
  ]
})
export class SidenavModule {
}
